export interface Constants {
  SUI_CLOCK_OBJECT_ID: string;

  SUI_SYSTEM_STATE_ID: string;

  // AlphaFi constants
  ALPHAFI_LATEST_ORACLE_PACKAGE_ID: string;

  ALPHAFI_FIRST_ORACLE_PACKAGE_ID: string;

  ALPHAFI_ORACLE_OBJECT_ID: string;

  ALPHAFI_ORACLE_ADMIN_CAP_ID: string;

  ALPHAFI_LATEST_STDLIB_PACKAGE_ID: string;

  ALPHAFI_FIRST_STDLIB_PACKAGE_ID: string;

  // AlphaLend constants
  ALPHALEND_LATEST_PACKAGE_ID: string;

  ALPHALEND_FIRST_PACKAGE_ID: string;

  LENDING_PROTOCOL_ID: string;

  LENDING_PROTOCOL_CAP_ID: string;

  LENDING_PROTOCOL_ADMIN_CAP_ID: string;

  POSITION_CAP_TYPE: string;

  POSITION_TABLE_ID: string;

  MARKETS_TABLE_ID: string;

  ACTIVE_MARKETS: number[];

  // Pyth Constants
  PYTH_PACKAGE_ID: string;

  PYTH_STATE_ID: string;

  WORMHOLE_PACKAGE_ID: string;

  WORMHOLE_STATE_ID: string;

  PYTH_PRICE_INDENTIFIER_TYPE: string;

  PYTH_MAINNET_API_ENDPOINT: string;

  PYTH_PRICE_PATH: string;

  // Coin Types
  SUI_COIN_TYPE: string;

  USDT_COIN_TYPE: string;

  USDC_COIN_TYPE: string;

  WUSDC_COIN_TYPE: string;

  VSUI_COIN_TYPE: string;

  STSUI_COIN_TYPE: string;

  ALPHA_COIN_TYPE: string;

  SUI_COIN_TYPE_LONG: string;

  // Deepbook (AlphaFi USDC → dbUSDC)
  DEEPBOOK_UPGRADE_CAP_ID: string;
  DEEPBOOK_USDC_POOL_ID: string;
  DEEPBOOK_MARGIN_REGISTRY: string;
  DEEPBOOK_USDC_MARGIN_POOL_ID: string;
  DBUSDC_COIN_TYPE: string;
}
